<template>
  <div class="sign-up-info">
    <h2 class="title is-3">{{ $t('signUp.title') }}</h2>
    <p class="sign-up-info-intro">{{ $t('signUp.intro') }}</p>
    <ol class="sign-up-info-steps">
      <li v-for="step in steps" :key="step.key" class="sign-up-info-step">
        <span class="sign-up-info-icon">
          <b-icon pack="fas" :icon="step.icon" />
        </span>
        <div>
          <p class="has-text-weight-bold">{{ $t(`signUp.steps.${step.key}.title`) }}</p>
          <p>{{ $t(`signUp.steps.${step.key}.text`) }}</p>
        </div>
      </li>
    </ol>
  </div>
</template>

<script>
// Sits where GearMenu sits on the login page: the gear's slices all lead to the
// public site, which is the wrong place to send someone halfway through sign-up.
export default {
  data() {
    return {
      steps: [
        { key: 'verify', icon: 'envelope' },
        { key: 'process', icon: 'tasks' },
        { key: 'answer', icon: 'clipboard-check' },
        { key: 'score', icon: 'chart-pie' }
      ]
    }
  }
}
</script>

<style scoped>
.sign-up-info {
  max-width: 520px;
  margin: 0 auto;
  font-size: 1.15rem;
  color: rgb(38, 55, 70);
}

.sign-up-info .title {
  color: rgb(38, 55, 70);
}

.sign-up-info-intro {
  margin-bottom: 2rem;
}

.sign-up-info-step {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.5rem;
}

.sign-up-info-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  margin-right: 1rem;
  border-radius: 50%;
  background-color: #31b4cb;
  color: #fff;
}
</style>
